import React from "react";
import { StatTile } from "@/components/ui/stat-tile";
import { translate } from "../../../../../utils/Common";

const round = (value) => Math.round(value * 10) / 10;

// Cambio en % contra el período anterior; sin base no hay porcentaje que mostrar
const percentDelta = (current, previous, positiveIsGood) =>
  previous ? { value: round(((current - previous) / previous) * 100), suffix: "%", positiveIsGood } : null;

const diffDelta = (current, previous, suffix, positiveIsGood) =>
  current == null || previous == null ? null : { value: round(current - previous), suffix, positiveIsGood };

const IncidentKpiRow = ({ summary, previous, loading }) => {
  const prev = previous || {};
  const vsPrevious = (value) => `${translate("dashboard.insights.incidents.kpi.previous")}: ${value ?? "—"}`;

  const tiles = [
    {
      key: "created",
      label: translate("dashboard.insights.incidents.kpi.created"),
      value: summary?.created,
      delta: percentDelta(summary?.created, prev.created, false),
      hint: vsPrevious(prev.created),
    },
    {
      key: "closed",
      label: translate("dashboard.insights.incidents.kpi.closed"),
      value: summary?.closed,
      delta: percentDelta(summary?.closed, prev.closed, true),
      hint: vsPrevious(prev.closed),
    },
    {
      key: "open",
      label: translate("dashboard.insights.incidents.kpi.open"),
      info: translate("dashboard.insights.incidents.kpi.open.message"),
      value: summary?.open,
      delta: percentDelta(summary?.open, prev.open, false),
      hint: vsPrevious(prev.open),
    },
    {
      key: "resolutionRate",
      label: translate("dashboard.insights.incidents.kpi.resolutionRate"),
      info: translate("dashboard.insights.incidents.kpi.resolutionRate.message"),
      value: summary?.resolutionRate == null ? "—" : `${summary.resolutionRate}%`,
      delta: diffDelta(summary?.resolutionRate, prev.resolutionRate, " pts", true),
      hint: vsPrevious(prev.resolutionRate == null ? null : `${prev.resolutionRate}%`),
    },
    {
      key: "avgResolutionTime",
      label: translate("dashboard.insights.incidents.kpi.avgResolutionTime"),
      info: translate("dashboard.insights.incidents.kpi.avgResolutionTime.message"),
      value: summary?.avgResolutionHours == null ? "—" : `${summary.avgResolutionHours} h`,
      delta: diffDelta(summary?.avgResolutionHours, prev.avgResolutionHours, " h", false),
      hint: vsPrevious(prev.avgResolutionHours == null ? null : `${prev.avgResolutionHours} h`),
    },
  ];

  return (
    <div className="grid w-full min-w-0 grid-cols-2 gap-3 md:grid-cols-3 xl:grid-cols-5">
      {tiles.map((tile, index) => (
        <div
          key={tile.key}
          className={`min-w-0 rounded-xl border border-border bg-muted/40 p-3 sm:p-4 ${index === tiles.length - 1 ? "col-span-2 md:col-span-1" : ""}`}
        >
          <StatTile
            loading={loading}
            label={tile.label}
            info={tile.info}
            value={tile.value ?? "—"}
            delta={tile.delta}
            hint={tile.hint}
          />
        </div>
      ))}
    </div>
  );
};

export default IncidentKpiRow;
